export default {
  validation: 1000,
};



// WEBPACK FOOTER //
// ./src/site-render/src/lib/errorCodes.js